import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { NAV_LINKS } from '../constants';

const Navbar: React.FC<{ isSign?: boolean }> = ({ isSign }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => location.pathname === path;

  const handleSignInClick = () => {
    if (isSign) {
      navigate('/dashboard');
      return;
    }
    window.location.href = "/auth/login";
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          {/* Logo */}
          <Link to="/home" className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
            <img
              src="https://otl.nyc3.cdn.digitaloceanspaces.com/fe/Logo-old.jpeg"
              alt="OTL"
              className="h-8 sm:h-10"
            />
            <span className="text-xl sm:text-2xl font-bold text-slate-800">Express</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            {NAV_LINKS.filter(link => !['Terms', 'Privacy'].includes(link.name)).slice(0, 7).map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`font-medium transition-colors text-sm lg:text-base ${isActive(link.href) ? 'text-brand-600 font-bold' : 'text-slate-600 hover:text-brand-600'}`}
              >
                {link.name}
              </Link>
            ))}
            <button onClick={() => handleSignInClick()} className="bg-brand-600 hover:bg-brand-700 text-white px-5 py-2.5 rounded-lg font-semibold transition shadow-md hover:shadow-lg text-sm">
              {isSign ? 'Dashboard' : 'Sign Up Free'}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-slate-600 hover:text-brand-600 p-2 focus:outline-none"
              aria-label="Toggle menu"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="lg:hidden absolute top-16 left-0 right-0 bg-white border-b border-slate-100 shadow-xl animate-fade-in max-h-[80vh] overflow-y-auto">
          <div className="px-4 pt-2 pb-6 space-y-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-3 text-base font-medium rounded-md ${isActive(link.href) ? 'bg-brand-50 text-brand-600' : 'text-slate-600 hover:text-brand-600 hover:bg-slate-50'}`}
              >
                {link.name}
              </Link>
            ))}

            <div className="border-t border-slate-100 mt-4 pt-4">
              <Link
                to="/home/rules"
                onClick={() => setIsOpen(false)}
                className="block px-3 py-3 text-base font-medium text-slate-600 hover:text-brand-600"
              >
                Rules & Regulations
              </Link>
            </div>

            <div className="pt-4 pb-20 md:pb-4">
              <button onClick={() => window.location.href = "/auth/login"} className="w-full bg-brand-600 text-white px-5 py-3 rounded-lg font-semibold shadow-md">
                Get Your Address
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;